import * as yup from 'yup';

export type DocumentRequirement = {
  entityToken: string;
  entityName: string;
  documentName: string;
};

type DocumentUploadProgress = {
  progress: number;
  progressComputable: boolean;
  uploading: boolean;
};

export type DocumentUploadState = DocumentRequirement &
  DocumentUploadProgress & {
    file: File | null;
  };

const requiredDocumentValidationSchema = yup.object({
  file: yup.mixed().nullable().required('Please upload this document to continue.'),
});

export const requiredDocumentsValidationSchema = yup.object({
  documents: yup.array(requiredDocumentValidationSchema),
});
